<template>
    <div class="v-center v-padded">
        <b-container class="v-center">
            <div class="main">
                <div>{{ $t("page404.oops") }}</div>
                <div>{{ $t("page404.notFound") }}</div>
            </div>
            <img src="/404.svg">
            <div class="desc">
                <div>{{ $t("page404.desc") }}</div>
            </div>
        </b-container>
    </div>
</template>

<script>
    export default {
        name: "NotFound"
    }
</script>

<style scoped>
    .main, .desc {
        margin: auto;
        text-transform: uppercase;
        font-size: 1.8rem;
        font-weight: bold;
        display: flex;
        flex-direction: row;
        margin: 0.3em auto;
        text-align: center;
    }

    .main div:first-child {
        margin-right: 0.5em;
    }

    .desc {
        max-width: 70%;
    }

    @media (max-width: 550px) {
        .main {
            flex-direction: column;
        }

        .main div:first-child {
            margin: 0;
        }

        .desc {
            max-width: 90%;
        }
    }

    img {
        min-height: 30vh;
        min-width: 50%;
        max-width: 60%;
        margin: auto;
        opacity: 0.7;
    }
</style>